import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactRef,
    DROPDOWN_MENU_COMPACT_SUBMENU_HOVER_OPEN_CLOSE_MS,
} from '../../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {elementGroups} from '../../../../../../constants/elementGroups';
import {useAddElementAction} from '../../../../../../context/AddElementsContext';

type MenuBarInsertDropdownProps = {
    insertMenuItemRef: React.RefObject<DropdownMenuCompactRef>;
    onHoverEnter: () => void;
};

function MenuBarInsertDropdown({insertMenuItemRef, onHoverEnter}: MenuBarInsertDropdownProps): JSX.Element {
    const {t} = useTranslation();
    const addElement = useAddElementAction();

    const insertMenuItems = useMemo(
        () => [
            elementGroups.map((elementGroup) => ({
                label: t(`menuBar.insertMenu.${elementGroup.label}`),
                items: [
                    elementGroup.items.map((element) => ({
                        label: t(`menuBar.insertMenu.element.${element.label}`),
                        icon: element.icon,
                        type: element.type,
                        elementProps: element.elementProps,
                        onClick: () => addElement(element.type, element.elementProps),
                        shortcuts: element.shortcut,
                    })),
                ],
            })),
        ],
        [t, addElement]
    );

    return (
        <DropdownMenuCompact
            ref={insertMenuItemRef}
            openOnMouseEnter
            closeOnMouseExit
            closeOnMouseExitDelayMs={DROPDOWN_MENU_COMPACT_SUBMENU_HOVER_OPEN_CLOSE_MS}
            onHoverEnter={onHoverEnter}
            items={insertMenuItems}
        >
            <Button size="2xs" disableHover square variant="ghost" className="c-menuBar__button">
                {t('menuBar.insert')}
            </Button>
        </DropdownMenuCompact>
    );
}

export default React.memo(MenuBarInsertDropdown);
